import { LoginResponse } from '@framework/api-client';
import { popSessionStorageLocation, RouteHistory } from '@framework/ui';
import { message } from 'antd';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AuthActions } from '../../state/AuthSlice';

/**
 *  Custom hook per il login centralizzato
 * @param history
 * @returns
 */
export function useLogin(history: RouteHistory<any>) {
  const dispatch = useDispatch();

  const onLogin = useCallback(
    (result: LoginResponse) => {
      if (!result.accessToken || !result.refreshToken) {
        console.error('Errore durante il login', result); // prettier-ignore
        message.error('Si è verificato un errore durante il login, nessun access token fornito.'); // prettier-ignore
        return;
      }
      dispatch(
        AuthActions.loginSucceed({
          strategy: 'jwt',
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
        }),
      );
      history.push((popSessionStorageLocation() ?? '/') as any);
    },
    [dispatch, history],
  );

  return onLogin;
}
